
import { useEffect } from 'react'
import {
    OnBlock,
    WeiToUnits,
    EtherToWei,
    Erc20,
    MultiCall,
    CreateProviderForRpc,
    GetGlobalSigner,
    CreateContract,
    DEFAULT_ACCOUNT,
    BN,
    Approves,
    BigToString,
    MAX256
} from '../../ethers/e'

import {
    Multi,
    SilverPool,
    Usdt
} from '../../chain/silver'

import {useEthers} from '../../ethers'
import useButtonText from '../useButtonText'
import useInput from '../useInput';
import useToast from '../useToast'

import {useSilver} from '../../context/silver'

import {
    isETHAddress,
    getUrlParams
} from '../../utils'

import { useTranslation } from 'react-i18next';

function Error(e) {
    const re = e.data ? e.data.data ? e.data.data.message : (e.data.message ? e.data.message : e.message) : e.message
    // console.log(re, ' re')
    return re || 'Input error'
}

// swap
export function useSwap(buy = true) {
    const {t} = useTranslation()
    const inputAmount = useInput("", {type: "number", placeholder: "0.0"})
    const {open} = useToast()
    const {
        button,
        loadingButton,
        initButton,
        // setButtonText,
        // setDisabled
    } = useButtonText(buy ? t('Buy') + " USDG" : t('Sell')+" USDG")

    button.onClick = async () => {
        loadingButton(t("Pending"))
        const usdt = Usdt()
        const silverPool = SilverPool()
        const _amountWei = EtherToWei(inputAmount.value, usdt[1])
        // 这里可以封装成组建
        let {
            tx,
            error
        } = await Approves(
            [
                {
                    token: usdt.token,
                    amountWei: _amountWei.mul(20),
                    sender: silverPool.address,
                    // isMax: true,
                    // needClear: true
                }
            ],
            {
                provider: GetGlobalSigner(),
                callback({
                    // status,
                    // token,
                    error
                }) {
                    // console.log("callback ", result)
                    // setButtonText("Approve")
                    if ( error ) {
                        open(t('Approve')+" "+t('Cancel'), "error")
                    } else {
                        open(t('Approve')+" "+t('Success'))
                    }
                    
            }
            }
        )

        try {
            if ( !error ) {
                buy && await tx.wait()
                tx = await silverPool.usdgToUsdt(_amountWei, buy) 
                await tx.wait()
                open((buy ? t('Buy'): t('Sell') ) + " "+ t('Success'))
            }
        } catch (e) {
            // console.log(e)
            open((buy ? t('Buy'): t('Sell') ) + ' '+t('Cancel'), "error")
        }
        
        // setButtonText("Pedding")
        // await tx.wait()
        // console.log("nonce ", nonce)
        initButton()
    }

    return {
        button,
        inputAmount
    }

}

// invest silver
export function useSilverInvest(pId, status) {
    // const {unlockPids} = useSilver()
    const inviter = useInput("", {placeholder: "0x...."})
    const inputAmount = useInput("", {type: "number", placeholder: "0.0"})
    const {open} = useToast()
    const {t} = useTranslation()

    const {
        button,
        loadingButton,
        initButton,
        // setButtonText,
        // setDisabled
    } = useButtonText(t('Purchase'))

    useEffect(() => {
        const {r} = getUrlParams()
        if (r) inviter.onChange(r)
    }, [])

    button.onClick = async () => {
        if (!isETHAddress(inviter.value)) {
            open(t("invit address error"), "error")
            return
        }

        loadingButton(t("Pending"))
        const silverPool = SilverPool()
        const _amountWei = EtherToWei(inputAmount.value)
        // let _inviter = inviter.value === '' ?  : inviter.value
        let inviterAddress = inviter.value

        inviterAddress = inviterAddress === -1 ?silverPool.address : inviterAddress
        try {
            // uint _amountUSDG, uint _pId, address _sponsor, uint16[] calldata _unlockPids
            let tx = await silverPool[status === 1 ? 'investFirst' :'invest'](_amountWei, pId, inviter.value, []) // unlockPids
            // let tx = await silverPool.invest(_amountWei, pId, inviter.value, [])
            await tx.wait()
            open(t("Success"))

            inviter.onChange(-1)
        } catch (e) {
            console.log(e)
            open(Error(e), "error")
        }
        initButton()
    }

    return {
        inputAmount,
        inviter,
        button
    }
}

export function useUnlockSilver() {
    const {unlockPids} = useSilver()
    const {account} = useEthers()
    const {open} = useToast()
    const {t} = useTranslation()

    const {
        button,
        loadingButton,
        initButton,
        // setButtonText,
        // setDisabled
    } = useButtonText(t('Harvest'))

    button.onClick = async () => {
        loadingButton(t("Pending"))
        const silverPool = SilverPool()
        try {
            // console.log(unlockPids, ' unlockPids')
            // uint _amountUSDG, uint _pId, address _sponsor, uint16[] calldata _unlockPids
            let tx = await silverPool.unlockUser(account, unlockPids)
            // let tx = await silverPool.invest(_amountWei, pId, inviter.value, [])
            await tx.wait()
            open(t("Success"))
        } catch (e) {
            console.log(e)
            open(Error(e), "error")
        }
        initButton()
    }

    return button
}

export function useBuySilver() {
    const {open} = useToast()
    const {
        button,
        loadingButton,
        initButton,
        // setButtonText,
        // setDisabled
    } = useButtonText('VIP')
    const {t} = useTranslation()

    button.onClick = async () => {
        loadingButton(t("Pending"))
        const silverPool = SilverPool()



        const usdt = Usdt()
        // 这里可以封装成组建
        let {
            tx,
            error
        } = await Approves(
            [
                {
                    token: usdt.token,
                    amountWei: MAX256,
                    sender: silverPool.address,
                    isMax: true,
                    needClear: true
                }
            ],
            {
                provider: GetGlobalSigner(),
                callback({
                    // status,
                    // token,
                    error
                }) {
                    // console.log("callback ", result)
                    // setButtonText("Approve")
                    if ( error ) {
                        open(t('Approve')+" "+t('Cancel'), "error")
                    } else {
                        open(t('Approve')+" "+t('Success'))
                    }
                    
            }
            }
        )

        try {
            // uint _amountUSDG, uint _pId, address _sponsor, uint16[] calldata _unlockPids
            if ( !error ) {
                await tx.wait()
            }
            tx = await silverPool.buySilver()
            // let tx = await silverPool.invest(_amountWei, pId, inviter.value, [])
            await tx.wait()
            open(t("Success"))
        } catch (e) {
            console.log(e)
            open(Error(e), "error")
        }
        initButton()
    }

    return button
}